import { PageController } from '@client/components/_core/layout/PageController';
import { IncidentFlagEdit } from '@client/components/incidents/IncidentFlagEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/flags/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New flag',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <IncidentFlagEdit action={['add']} />
        </PageController>
    );
}
